// Price formatting. Prices are stored and settled in the base currency (RUB);
// the buyer may pick a *display* currency (location modal) and we convert with
// the currency's `rate` for presentation only — matches seller-web's
// `{fmt.number(price)} ₽` when left at the RUB default.
import { formatPrice as formatSharedPrice } from "@osmix/formatters";
import type { Currency } from "@/api";

// Base currency (rate 1). Default for non-interactive callers and the
// preferences store's initial value.
export const BASE_CURRENCY: Currency = {
	code: "RUB",
	symbol: "₽",
	name: "Российский рубль",
	rate: 1,
	symbolBefore: false,
};

/** Узкий неразрывный пробел (U+202F) — между разрядами: «12 800». */
export const THIN_SPACE = "\u202F";
/** Неразрывный пробел (U+00A0) — между числом и символом валюты: «12 800 ₽». */
export const NBSP = "\u00A0";

// Пробел между цифрами, который ставит Intl ru-RU (U+00A0), обычный или узкий.
const GROUP_SEPARATOR = /(\d)[\u0020\u00A0\u2009\u202F](?=\d)/g;

// Цена по макету (A-09, Айталы 02.10.2026): тысячи разделяются тонким пробелом,
// «₽» не переносится отдельно от числа, цифры не разрываются. Оба пробела —
// неразрывные, поэтому строка цены целиком не рвётся и в тостах, и в подписях
// вида «6 товаров 50 374,70 ₽». Узкий пробел в Manrope отсутствует — ширину
// 1/6 em ему даёт шрифт «OSMIX Thin Space» — первый в стеке (styles/globals.css).
export const formatPrice = (rubValue: number, currency: Currency = BASE_CURRENCY): string =>
	formatSharedPrice(rubValue, currency, { separator: NBSP }).replace(GROUP_SEPARATOR, `$1${THIN_SPACE}`);
